import styled from 'styled-components';

const SectionSubheader = styled.p`
    font-size: 17px;
    font-family: Roboto Condensed, serif;
    color: black;
    margin: 5px;
    max-width: 800px;
    text-align: center;
    font-weight: 300;
    margin-top: 20px;    
`;

export default SectionSubheader;
